import {AxisMapped, ReportSheet, YAxisID} from "interfaces/report";
import * as _ from "lodash";
import { Bar } from "react-chartjs-2";
import { getTextColor, randomColor } from "utils/string";
import numeral from "numeral";
import {Context} from "chartjs-plugin-datalabels/types/context";

interface Props {
  sheet: ReportSheet<AxisMapped>;
  print?: boolean;
}

export const StackedBarGroupChart = ({ sheet, print }: Props) => {
  const mergedYValue = _.chain(sheet.yAxis.filter((item) => !item.hide))
    .map("value")
    .uniq()
    .join(" | ")
    .value();

  const xLables = sheet.data
    .find(
      (items) => items[0] === sheet.yAxis.find((ele) => ele.isFieldGroup)?.value
    )
    ?.slice(1) as string[];
  const xAxis = sheet.xAxis.map((item) => item.value);

  const xData = sheet.data
    .find(
      (items) =>
        items[0] === sheet.yAxis.find((ele) => !ele.hide && ele.active)?.value
    )
    ?.slice(1) as number[];

  const isSameLabelAxis =
    sheet.yAxis.find((ele) => ele.isXAxis)?.value ===
    sheet.yAxis.find((ele) => ele.isFieldGroup)?.value;

  const groupedData = (xLables || []).reduce((acc: any, item: any, index) => {
    if (!acc[item]) {
      acc[item] = [];
    }
    let value = null;
    try {
      value = _.keys(_.groupBy(xAxis)).map((ele, idx) => {
        return !_.isNil(acc?.[item]?.[idx])
            ? isSameLabelAxis
                ? acc[item][idx] + xData[index]
                : acc[item][idx]
            : xAxis[index] === ele
                ? xData[index]
                : null;
      });
    } catch (e) {
      value = null;
    }

    acc[item] = value;
    return acc;
  }, {});

  const data = {
    labels: _.keys(_.groupBy(xAxis)),
    datasets: _.keys(groupedData).map((key, idx) => {
      const color = randomColor();

      return {
        label: key,
        data: (groupedData[key] || []).map((ele: any) => ele || 0),
        borderColor: color,
        backgroundColor: color,
      };
    }),
  };

  return (
    <Bar
      options={{
        scales: {
          x: {
            stacked: true,
          },
          y: {
            ticks: {
              // Include a dollar sign in the ticks
              callback: function(value, index, ticks) {
                const unit = sheet.yAxis.find((axis) => axis.yAxisID === YAxisID.Y)?.unit;
                if (unit === '%') {
                  return numeral(value).format('0%');
                } else {
                  return numeral(value).format(`${unit}0.0a`);
                }
              }
            },
            stacked: true,
            title: {
              display: false,
              text: mergedYValue,
            },
          },
        },
        responsive: true,
        plugins: {
          datalabels: {
            display: function (ctx: any) {
              const value = ctx.dataset.data[ctx.dataIndex];
              return value > 0;
            },

            formatter: (value: any, context: Context) => {
              console.log('context:', context);
              return `${context.dataset.label} (${numeral(context.dataset.data[context.dataIndex]).format('0,0')})`;
            },
            color: (context) => {
              return getTextColor(context.dataset.backgroundColor as string);
            },
          },
          tooltip: {
            callbacks: {
              label(tooltipItem) {
                const formatted = numeral(tooltipItem.parsed.y).value()?.toLocaleString("en-AU");

                return `${tooltipItem.dataset.label}: ${formatted}`;
              },
            },
          },
          legend: {
            display: false,
          },
        },
      }}
      data={data}
    />
  );
};
